
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/knowledge/index/[slug]",
      function () {
        return require("private-next-pages/knowledge/index/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/knowledge/index/[slug]"])
      });
    }
  